module.exports = __webpack_public_path__ + "static/media/csvicon.7bc12442.svg";